import { useEffect, useState } from 'react';
import { AdminSidebar } from '../../components/Sidebar';
import api from '../../utils/api';

const STATUS = {
  pending: { label: 'Ausstehend', cls: 'badge-orange' },
  paid:    { label: 'Bezahlt',    cls: 'badge-green'  },
  overdue: { label: 'Überfällig', cls: 'badge-error'  },
};

const PLAN = { free: 'Kostenlos', standard: 'Standard', premium: 'Premium' };

export default function AdminInvoices() {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/invoices')
      .then(r => setInvoices(r.data.invoices || []))
      .finally(() => setLoading(false));
  }, []);

  const downloadPDF = async (inv) => {
    try {
      const res = await fetch(`/api/admin/invoices/${inv.id}/pdf`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('zq_token')}` },
      });
      if (!res.ok) { alert('PDF nicht verfügbar'); return; }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Rechnung-${inv.invoice_number}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch {
      alert('Fehler beim Herunterladen');
    }
  };

  return (
    <div style={{ display: 'flex' }}>
      <AdminSidebar />
      <main className="main-content">
        <h1 style={{ fontSize: 28, marginBottom: 24 }}>Rechnungen</h1>

        {loading ? (
          <div className="spinner-wrap"><div className="spinner" /></div>
        ) : invoices.length === 0 ? (
          <div className="card" style={{ textAlign: 'center', padding: 48 }}>
            <p style={{ color: 'var(--text3)' }}>Noch keine Rechnungen vorhanden</p>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {invoices.map(inv => {
              const si = STATUS[inv.status] || { label: inv.status, cls: 'badge-gray' };
              const from = inv.period_start ? new Date(inv.period_start).toLocaleDateString('de-CH') : '—';
              const to   = inv.period_end   ? new Date(inv.period_end).toLocaleDateString('de-CH')   : '—';
              return (
                <div key={inv.id} className="card" style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
                      <span style={{ fontWeight: 700, fontSize: 15, fontFamily: 'monospace' }}>
                        {inv.invoice_number}
                      </span>
                      <span className={`badge ${si.cls}`}>{si.label}</span>
                      <span className="badge badge-gray">{PLAN[inv.plan] || inv.plan}</span>
                    </div>
                    <div style={{ color: 'var(--text3)', fontSize: 13 }}>
                      Zeitraum: {from} – {to}
                      {inv.due_date && inv.status !== 'paid' && (
                        <span style={{ marginLeft: 12, color: '#B8650C' }}>
                          Fällig bis: {new Date(inv.due_date).toLocaleDateString('de-CH')}
                        </span>
                      )}
                      {inv.payment_date && (
                        <span style={{ marginLeft: 12 }}>
                          Bezahlt: {new Date(inv.payment_date).toLocaleDateString('de-CH')}
                        </span>
                      )}
                    </div>
                  </div>

                  <div style={{ fontWeight: 700, fontSize: 18, color: 'var(--primary)', whiteSpace: 'nowrap' }}>
                    {parseFloat(inv.amount).toFixed(2)} {inv.currency || 'CHF'}
                  </div>

                  <div style={{ display: 'flex', gap: 8 }}>
                    {inv.pdf_path && (
                      <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => downloadPDF(inv)}
                      >
                        PDF
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </main>
    </div>
  );
}
